// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

import {
  Col,
  Collapse,
  Row,
} from 'reactstrap'

export const ContactRow = styled(Row)`
  background: #1a1a1a;
  padding: .5em 1em 0;
`

export const ContactCol = styled(Col)`
  padding-top: 1em;
  padding-bottom: 1em;
`

export const CollapseInfo = styled(Collapse)`
  > ul {
    list-style-type: none;
    padding: 0;
    margin: 0;

    > li {
      line-height: 1.2;

      > a {
        color: #1EAFEC;
      }
    }
  }
`

export const FooterDiv = styled.div`
  color: #fff;
  margin-bottom: 0;

  // sm size in bootstrap
  @media (min-width: 576px) {
    > h5 {
      > svg {
        display: none !important;
      }
    }

    > ${CollapseInfo} {
      display: block !important;
    }
  }

  > ul {
    list-style-type: none;
    padding: 0;
    margin: 0;

    > li {
      line-height: 1.2;

      > a {
        color: #1EAFEC;
      }
    }
  }
`

export const ContactExpertLink = styled.a`
  border: thin #FF9900 solid;
  color: #fff;
  display: inline-block;
  margin-bottom: 1em;
  padding: 1em;
  transition: color .3s ease, border-color .3s ease;

  &:hover {
    border-color: #fff;
    color: #FF9900;
    text-decoration: none;
  }
`
export const Contacts = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`
export const Wrapper = styled.div`
  background: #0d0d0d;
  color: #fff;
  display: flex;
  font-size: .85rem;
  padding: .5em 1em;

  > a,
  > a:hover {
    color: inherit;
  }

  > span {
    > a, > a:hover {
      color: #1EAFEC;
    }
  }
`
